import
{
  AfterViewInit,
  Component,
  ElementRef,
  Injector,
  Input,
} from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Component({
  selector: '[formError]',
  template: '{{ error }}',
})
export class FormErrorDirective implements AfterViewInit
{
  @Input() placeholder = '';
  error = null;
  abstractControl: AbstractControl;

  constructor(private el: ElementRef, private injector: Injector) { }

  ngAfterViewInit()
  {
    const container = this.injector.get(NgControl);
    this.abstractControl = container.control;
    this.abstractControl.statusChanges.subscribe(this.updateErrors);
  }

  private updateErrors = (state: 'VALID' | 'INVALID') =>
  {
    if (state === 'VALID')
    {
      this.clearErrors();
      return;
    }

    this.processErrors();
  };

  private processErrors()
  {
    const controlErrors = this.abstractControl.errors;
    if (!controlErrors)
    {
      this.clearErrors();
      return;
    }

    this.handleError('mustMatch', 'Contraseñas no coinciden');
    this.handleError('emailTaken', controlErrors.mensajeError || 'Este correo ya se encuentra registrado, ve a iniciar sesión.');
    this.handleError('email', 'Ingrese un correo válido.');
    this.handleLengthError(controlErrors.minlength, 'min');
    this.handleLengthError(controlErrors.maxlength, 'max');
    this.handleDigitLengthError(controlErrors.digitLength);
    this.handleError('required', this.placeholder + ' es requerido.' || 'Este campo es requerido.');
    this.handleError('incorrect', 'Campo incorrecto');
    this.handleError('passwordPattern', 'Se requiere al menos una letra mayúscula y un número');
  }

  private handleLengthError(error, type: 'min' | 'max')
  {
    if (!error) return;
    const message = type === 'min'
      ? `Este campo requiere mínimo ${error.requiredLength} caracteres.`
      : `Este campo requiere solo ${error.requiredLength} caracteres.`;
    this.setError(message);
  }

  private handleError(key: string, message: string)
  {
    if (!this.abstractControl.errors[key]) return;
    this.setError(message);
  }
  private handleDigitLengthError(error)
  {
    if (!error) return;
    const message = `Este campo requiere exactamente ${error.requiredLength} dígitos.`;
    this.setError(message);
  }
  private setError(message: string)
  {
    this.error = message;
    this.el.nativeElement.setAttribute('error', this.error);
  }

  private clearErrors()
  {
    this.el.nativeElement.removeAttribute('error');
    this.error = null;
  }
}
